import type { FC } from "react";

import { useDispatch } from "react-redux";

import { SWReactIcons } from "@similarweb/icons";
import { Button } from "@similarweb/ui-components";

import { ProModal } from "pro-features/components/Modals/src/ProModal";
import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import { setIsShowAssignToUserModal } from "app/pages/sales-intelligence/sub-modules/assign-to-users/store/actions-creators";
import type { Translatable } from "app/pages/sales-intelligence/types";

import { modalStyles, StyledImageContainer, StyledModalFooter, StyledTitle } from "./styles";

type AssignToUserModalProps = {
    isOpen: boolean;
    titleTranslatable: Translatable;
};

const AssignToUserModal: FC<AssignToUserModalProps> = ({ isOpen, titleTranslatable }) => {
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(setIsShowAssignToUserModal(false));
    };

    return (
        <ProModal
            isOpen={isOpen}
            showCloseIcon={false}
            shouldCloseOnOverlayClick={false}
            customStyles={modalStyles}
        >
            <I18n
                translatable={titleTranslatable}
                element={StyledTitle}
            />
            <StyledImageContainer>
                <SWReactIcons iconName="websites-assign-to-user" />
            </StyledImageContainer>
            <StyledModalFooter>
                <Button onClick={handleClose}>{translate("si.assigned-to-user-modal.button.got-it")}</Button>
            </StyledModalFooter>
        </ProModal>
    );
};

export default AssignToUserModal;
